import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";

import { validate, validateProperty } from "../common/validate";

import { attemptCreateOrder } from "../../store/thunks/order";
import routes from "../../routes";

import { Input } from "../common/Input";
import ServerAlert from "../common/ServerAlert";

const GetStarted = ({ history }) => {
  const initialDataState = useSelector(({ order }) => order.data);
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const [submitOnce, setSubmitOnce] = useState(false);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setData(initialDataState);
  }, [initialDataState]);

  const doSubmit = async () => {
    await dispatch(attemptCreateOrder(data))
      .then(() => {
        setLoading(false);
        window.doorbell.setProperty("Order ID", data.id);
        history.push(routes.template);
      })
      .catch(error => {
        if (error.response && error.response.status === 400) {
          setErrors({
            ...errors,
            server: error.response.data.message
          });
        }
        setLoading(false);
      });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    const errors = validate(data, "get_started");
    setErrors(errors || {});
    setSubmitOnce(true);
    if (errors) {
      setLoading(false);
      return;
    }

    doSubmit();
  };

  const handleChange = ({ currentTarget: input }) => {
    if (submitOnce) {
      const newErrors = { ...errors };
      const errorMessage = validateProperty(input, "get_started");
      if (errorMessage) newErrors[input.name] = errorMessage;
      else delete newErrors[input.name];
      setErrors(newErrors);
    }

    setData({
      ...data,
      [input.name]: input.value
    });
  };

  return (
    <>
      <h1 className="mb-2">Get Started</h1>
      <p className="mb-lg w-75 text-center">
        To begin, enter your wedding details below.
      </p>
      <form noValidate onSubmit={handleSubmit}>
        <div className="row mb-md mb-md-mobile-off">
          <div className="col-12 col-md-6">
            <Input
              label="NAME"
              name="first_name"
              data={data}
              errors={errors}
              type="text"
              onChange={handleChange}
              placeholder="(PERSON 1)"
            />
          </div>
          <div className="col-12 col-md-6">
            <Input
              label="NAME"
              name="second_name"
              data={data}
              errors={errors}
              type="text"
              onChange={handleChange}
              placeholder="(PERSON 2)"
            />
          </div>
        </div>
        <div className="row mb-md">
          <div className="col-12 col-md-6">
            <Input
              label="WEDDING DATE"
              name="date"
              data={data}
              errors={errors}
              type="text"
              onChange={handleChange}
              placeholder="(AS IT SHOULD APPEAR)"
            />
          </div>
          <div className="col-12 col-md-6">
            <Input
              label="LOCATION"
              name="location"
              data={data}
              errors={errors}
              type="text"
              onChange={handleChange}
              placeholder="(OPTIONAL)"
            />
          </div>
        </div>
        <div className="text-center">
          <button
            type="submit"
            className="btn btn-primary mb-3"
            disabled={loading}
          >
            {!loading ? (
              <>NEXT</>
            ) : (
              <div className="dots dots-light mx-auto"></div>
            )}
          </button>
          <ServerAlert error={errors["server"]} />
        </div>
      </form>
    </>
  );
};

export default withRouter(GetStarted);
